import mainStyle from "../mainStyle.module.scss";
import React, { useState, useEffect, memo } from 'react';
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidWarnButton } from "components/buttons/SolidWarnButton";

const ModalforCheck = (props) => {
  const {
    title, content, 
    cancelBtn, saveBtn, saveAlert, 
    setOpenModal, setModalAction
  } = props;
  const theme = useTheme();

  const handleClose = () => {
    setModalAction(false)
    setOpenModal(false);
  };

  const handleSave = () => {
    setModalAction(true)
    setOpenModal(false);
  };

  return (
    <>
      <div className={mainStyle['modal_Block']} style={{margin:'10px 0px 20px 0px'}}>
        {title &&
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            {title}
          </Typography>
        }
        {/* <IconButton style={newOpenTheme} onClick={handleClose}>
          <img src={close} alt="openInNew" width={"25px"} />
        </IconButton> */}
      </div>
      <div className={mainStyle['modal_Block']} style={{margin: '15px 10px 25px 10px', textAlign:'center'}}>
        {content && 
        <>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            {content}
          </Typography>
        </>
        }
      </div>
      <div className={mainStyle['modal_Block']}>
        {cancelBtn && <Box style={{margin: '10px'}}>
          <OutlineButton width="135px" height="42px" onClick={handleClose}>
          {cancelBtn}
          </OutlineButton>
        </Box>}
        {saveBtn && <Box style={{margin: '10px'}}>
          {(saveAlert) ? 
            <SolidWarnButton width="135px" height="42px" onClick={handleSave}>
              {saveBtn}
            </SolidWarnButton>
            :
            <SolidButton width="135px" height="42px" onClick={handleSave}>
              {saveBtn}
            </SolidButton>
          }
        </Box>}
      </div>
    </>
  );
}

export default memo(ModalforCheck);